<template>
  <transition name="fade">
    <div class="message-modal-wrapper">
      <div class="modal-bg" @click="onClickBg"/>
      <div :class="['modal-inner', { 'sign-up': signUp }]">
        <img class="close-modal" :src="require('assets/images/curation/close_modal.svg')"  width="20" height="20" @click="onClickBg">
        <slot>
          <h3>
            詳細モーダルです
          </h3>
        </slot>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    signUp: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    onClickBg: function() {
      this.$emit('onClickBg')
    }
  }
}
</script>

<style lang="scss">
$breakpoint: 767px;

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.message-modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  z-index: 4;

  .modal-bg {
    background: rgba(0,0,0,0.5);
    height: 100vh;
    position: absolute;
    width: 100%;
  }

  .modal-inner {
    overflow: auto;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    border-radius: 6px;
    background: #fff;
    padding: 50px;
    max-width: 900px;
    width: calc(100% - 20px);
    height: calc(100% - 100px);

    &.sign-up {
      width: auto;
      height: auto;

      @media screen and (max-width: $breakpoint) {
        padding: 55px 20px;
      }
    }

    h3 {
      font-size: 15px;
    }

    @media screen and (max-width: $breakpoint) {
      padding: 55px 20px 0 20px;
      height: calc(100% - 20px);
    }
    
    .close-modal {
      cursor: pointer;
      position: absolute;
      top: 20px;
      right: 30px;
    }
  }
}
</style>
